var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe-return"},[_vm._v(_vm._s(_vm.langJson('Returning to your event…')))])
}
var staticRenderFns = []

export { render, staticRenderFns }